<div class="page">
    <div class="title">
        <button class="buttonBack" (click)="irAUrlAnterior()"><mat-icon>arrow_back</mat-icon></button>
        <div class="titleValue">{{ "legalWarning.title" | transloco }}</div>
        <div class="line"></div>
    </div>

    <div class="content">
        <p [innerHTML]="'legalWarning.intro.p1' | transloco"></p>
        <p [innerHTML]="'legalWarning.intro.p2' | transloco"></p>
        
        <h3>{{ "legalWarning.userResponsibility.title" | transloco }}</h3>
        <p>{{ "legalWarning.userResponsibility.p1" | transloco }}</p>
        <p>{{ "legalWarning.userResponsibility.p2" | transloco }}</p>
        <ul>
            <li *ngFor="let item of ('legalWarning.userResponsibility.list' | transloco)">{{item}}</li>
        </ul>
        <h3>{{ "legalWarning.linksPolicy.title" | transloco }}</h3>
        <p>{{ "legalWarning.linksPolicy.p1" | transloco }}</p>
        <p>{{ "legalWarning.linksPolicy.p2" | transloco }}</p>
        <h3>{{ "legalWarning.modifications.title" | transloco }}</h3>
        <p>{{ "legalWarning.modifications.p1" | transloco }}</p>
        <h3>{{ "legalWarning.onlineServices.title" | transloco }}</h3>
        <p>{{ "legalWarning.onlineServices.p1" | transloco }}</p>
        <h3>{{ "legalWarning.dataProtection.title" | transloco }}</h3>
        <p>{{ "legalWarning.dataProtection.p1" | transloco }}</p>
        <p>{{ "legalWarning.dataProtection.p2" | transloco }}</p>
        <p>{{ "legalWarning.dataProtection.p3" | transloco }}</p>
        <p [innerHTML]="'legalWarning.dataProtection.p4' | transloco"></p>
        <p>{{ "legalWarning.dataProtection.p5" | transloco }}</p>
        <h3>{{ "legalWarning.intellectualProperty.title" | transloco }}</h3>
        <p>{{ "legalWarning.intellectualProperty.p1" | transloco }}</p>
        <p>{{ "legalWarning.intellectualProperty.p2" | transloco }}</p>
        <p>{{ "legalWarning.intellectualProperty.p3" | transloco }}</p>
        <h3>{{ "legalWarning.legalActions.title" | transloco }}</h3>
        <p>{{ "legalWarning.legalActions.p1" | transloco }}</p>
        <p>{{ "legalWarning.legalActions.p2" | transloco }}</p>
    </div>
</div>
